import React, { useState, useEffect, useContext, useRef } from "react";
import { useTranslate } from 'react-redux-multilingual'
import { ArticleBarSearch} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { personalizedPriceDescription,personalizedPricePrefixe } from 'app/allPersonalizedPrice';
import { useForm } from "react-hook-form";
import CheckBoxCompany from './Comp/CheckBoxCompany'
import {IsAuthContext} from 'app/App';

const useLoad = (modalEditId,setValue,setShowInputPromo,personalizedPriceProfilId,props)=>{
    const t = useTranslate();
    const [loading,setLoading]=useState(false)
    const [promoOne,setPromoOne]=useState({})
    const [disabled,setDisabled]=useState(false)
    const [articleId,setArticleId]=useState(false) 
    const [inputScan,setInputScan]=useState('') // Pour input article
    
    //En cas d'édition, on récupère les infos de la promo concerné pour les attribuer aux champs 
    useEffect(function () {
        (async function() {
            if(modalEditId || personalizedPriceProfilId){
                let idPromo = (modalEditId) ? modalEditId : personalizedPriceProfilId
                setLoading(true)
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/personalized_price/"+idPromo
                ).then((response) => {
                    setPromoOne(response.data.data)
                    setShowInputPromo(response.data.data.type)
                    setValue('type',response.data.data.type)
                    setArticleId(response.data.data.article_id)
                    setInputScan(response.data.data.article.name)

                    let promoStr = ''
                    response.data.data.value.map(promoAmount=>{
                        if(promoStr == ''){
                            promoStr += promoAmount
                        }else{
                            promoStr += ','+promoAmount
                        }
                        
                    })
                    setValue('value',promoStr)
                    if(response.data.data.begin!=null){
                        let beginFormated = response.data.data.begin.split(/[-\s]+/)
                        setValue('begin',beginFormated[0]+'-'+beginFormated[1]+'-'+beginFormated[2])
                    }
                    if(response.data.data.end!=null){
                        let endFormated = response.data.data.end.split(/[-\s]+/)
                        setValue('end',endFormated[0]+'-'+endFormated[1]+'-'+endFormated[2])
                    }

                    setDisabled(true)
                    setLoading(false)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                    swal.fire(t(errorName), "", "error");
                    setLoading(false)
                })
            }
            else {
                if (props.type) setValue('type',props.type)
            }
        })()
    }, [])

    // Pour input article
    const [loadingSearchItem,setLoadingSearchItem]=useState(false)
    const [listSearchItem,setListSearchItem]=useState([])
    const [datas,setDatas] = useState(listSearchItem)
    const searchInput = useRef('')

    const loadItems = async (inputValue) => {
        setLoadingSearchItem(prev=>true)
        const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/article/name/"+inputValue
        ).then((response) => {
            setListSearchItem(prev=>response.data.datas)
            let ajour = response.data.datas.filter((value)=>value.name.replace(/\u00A0/g,' ').toLowerCase().includes(searchInput.current.value.replace(/\u00A0/g,' ').toLowerCase()))
            setDatas(prev=>ajour)
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setLoadingSearchItem(prev=>false)
    }

    return [loading,promoOne,disabled,setDisabled,loadingSearchItem,setLoadingSearchItem,listSearchItem,setListSearchItem,datas,setDatas,searchInput,loadItems,articleId,setArticleId,inputScan,setInputScan]
}


const CreatePersonalizedPriceForm = (props) =>{
    const t = useTranslate();
    const { register, formState: { errors }, handleSubmit, setValue, reset} = useForm();
    const [showInputPromo, setShowInputPromo]=useState(props.type ?? false)
    const [loading,promoOne,disabled,setDisabled,loadingSearchItem,setLoadingSearchItem,listSearchItem,setListSearchItem,datas,setDatas,searchInput,loadItems,articleId,setArticleId,inputScan,setInputScan]=useLoad(props.modalEditId,setValue,setShowInputPromo,props.personalizedPriceProfilId,props)
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [selectedCompany,setSelectedCompany] = useState([])
    const { authParam } = useContext(IsAuthContext)

    let devise = authParam.company.devise;
        
    let prefixePercent = (showInputPromo && (showInputPromo=='percent' || showInputPromo=='suppercent')) ? true : false
    let prefixePrixfixe = (showInputPromo && showInputPromo=='prixfixe') ? true : false

    let addOn = (prefixePercent) ? '%' : (prefixePrixfixe) ? devise : '-';

    const handleChange = (e) =>{
        setShowInputPromo(e.target.value)
    }

    let editPromo = props.from=='profilPromo' ? props.personalizedPrices.id : props.personalizedPrices.find(value=>value.id==props.modalEditId)

    if(props.modalEditId){
        //On détermine l'index à éditer sur la modal edit 
        let refPromo = props.personalizedPrices.map(value=>value.id)
        var indexToEdit = refPromo.indexOf(editPromo.id)
    }

    const onSubmit = async (data) => {
        let idPromo = (props.modalEditId) ? props.modalEditId : props.personalizedPriceProfilId
        setValidButton(true)
        setApiError(false)
        
        // let arrayOtherCompany = (Array.isArray(data.other_company) && data.other_company.includes(props.company.id+'-company')) ? data.other_company.filter(value=>value!=props.company.id+'-company') : (Array.isArray(data.other_company) && !data.other_company.includes(props.company.id+'-company')) && data.other_company

        let companyPost = (Array.isArray(data.other_company) && data.other_company.includes(props.company.id+'-company')) ? props.company.id : data.other_company == props.company.id+'-company' ? props.company.id : null
        
        let otherCompanyPost 
        // = (!Array.isArray(data.other_company) && data.other_company!=props.company.id+'-company') ? [data.other_company] : (!Array.isArray(data.other_company) && data.other_company==props.company.id+'-company') ? [] : (data.other_company==false) ? [] : arrayOtherCompany

        if(Array.isArray(data.other_company) && data.other_company.includes(props.company.id+'-company')){
            //Si data.other_company est un array et que ce [] inclut l'id de la company
            //on retourne un [] sans l'id de la company
            otherCompanyPost = data.other_company.filter(value=>value!=props.company.id+'-company')

        }else if(Array.isArray(data.other_company) && !data.other_company.includes(props.company.id+'-company')){
            //Si data.other_company n'inclut pas l'id de la company
            otherCompanyPost = data.other_company

        }else if(!Array.isArray(data.other_company) && data.other_company!=props.company.id+'-company' && data.other_company!=false){
            //Si une seule other company et que ce n'est pas la company
            otherCompanyPost = [data.other_company]

        }else if((!Array.isArray(data.other_company) && data.other_company==props.company.id+'-company') || data.other_company==false){
            //Si la company a été choisi ou que aucune other company ni la company n'a été choisi
            otherCompanyPost = []
        }

        let obj={
            begin: data.begin,
            end: data.end,
            company: companyPost,
            other_company: otherCompanyPost,
            type: data.type,
            value: data.value,
            client_id:props.clientId,
            article_id:articleId
        }
        
        if(props.modalEditId || props.personalizedPriceProfilId){//Edition d'un personalized_price
            const response  = await axios.put(process.env.REACT_APP_API_URL+"api/erp/personalized_price/edit/"+idPromo,obj
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
                }
                else{
                    props.setRelance(Date.now())
                    if(props.from=='profilPromo'){
                        props.setPersonalizedPrices(response.data.data)
                    }else{
                        let newData = props.personalizedPrices.filter(value=>value.id!=props.modalEditId)
                        newData.splice(indexToEdit,0, response.data.data)
                        props.setPersonalizedPrices(newData)
                    }
                    props.closeModal()
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })

        }else{//Création d'un personalized_price
            const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/personalized_price/create",obj
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                        messageError=messageError.replace('undefined','');
                        setApiError(messageError)
                }
                else{                    
                    props.setPersonalizedPrices([response.data.data,...props.personalizedPrices])
                    props.setRelance(Date.now())
                    props.closeModal()
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
                swal.fire(t(errorName), "", "error");
            })
        }
        setValidButton(false)
        setDisabled(false)
    }

    const addNewItem = async (e,articleid,inputname,articleBar) =>{//selection l'article dans l'input data
        let article = (e) ? e.target.value : articleid
        let urlArticle = (e) ? "api/erp/article/reference/" : "api/erp/article/one/"
        
        setLoadingSearchItem(prev=>true)
        const response = await axios.get(process.env.REACT_APP_API_URL+urlArticle+article
        ).then((response) => {
            if(response.data.hasOwnProperty('valid') && !response.data.valid){
                swal.fire(t('articleNoReferenceFind'), "", "error");
            }else{        
                setArticleId(prev=>(e) ? response.data.data.article.id : response.data.data.id)
                setLoadingSearchItem(prev=>false)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
    }

    return(
        <>
            {loading ? 
                <span className="d-flex justify-content-center"><div className="spinner-border spinner-border-sm"></div></span>
            :
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group row">
                        <label>{t('addItem')}</label>
                        <ArticleBarSearch 
                            loadingSearchItem={loadingSearchItem}
                            loadItems={loadItems}
                            listSearchItem={listSearchItem}
                            datas={datas}
                            setDatas={setDatas}
                            valueInput={inputScan}
                            setValueInput={setInputScan}
                            handleSubmit={addNewItem}
                            searchInput={searchInput}
                            noBlur={true}
                            icon='true'
                            setArticle={setArticleId}
                            disabled={articleId}
                            noBtnErase={props.modalEditId || props.personalizedPriceProfilId}
                        />
                    </div>
                    {(!articleId) ?
                        false
                    :
                        <>
                            <div className="form-group row">
                                <label>{t('company')}</label>
                                <div className="col-3">
                                    <CheckBoxCompany otherCompany={props.company} register={register} promoOne={promoOne} modalEditId={editPromo} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} showInputPromo={showInputPromo} setShowInputPromo={setShowInputPromo} reset={reset} isCompany="true"/>
                                </div>
                                {(Object.keys(props.company).length!=0 && props.company.other_company.length!=0) && props.company.other_company.map((otherCompany)=>
                                    <div key={otherCompany.id} className="col-3">
                                        <CheckBoxCompany otherCompany={otherCompany} register={register} promoOne={promoOne} modalEditId={editPromo} selectedCompany={selectedCompany} setSelectedCompany={setSelectedCompany} showInputPromo={showInputPromo} setShowInputPromo={setShowInputPromo} reset={reset} isCompany="false"/>
                                    </div>
                                )}
                            </div>
                            <div className="form-group">
                                <label htmlFor="type de promotion">Type* :</label>
                                <select  disabled={disabled} className="form-control" type="text"  {...register('type', {required: true, onChange: (e) => handleChange(e)})}>
                                    <option value="">-- Select --</option>
                                    {
                                        props.allPersonalizedPrice.map((value,ind)=>{
                                            if(selectedCompany.length!=0){
                                                if(value=='percent' || value=='franche' || value=='prixfixe'){
                                                    return(
                                                        <option key={ind} value={value}>{t(value)}</option>
                                                    )
                                                }
                                            }else{
                                                return(
                                                    <option key={ind} value={value}>{t(value)}</option>
                                                )
                                            }
                                        })
                                    }                               
                                </select>
                                {errors.type?.type === 'required' && (
                                <div className="text-danger mt-1 ml-2">
                                    {t('typeRequired')}
                                </div>
                                )}
                            </div>
                            {(!showInputPromo) ?
                                false
                            :
                                <div className="alert alert-warning mt-3" role="alert">
                                    {(showInputPromo=='franche' || showInputPromo=='xpourfixe') ?
                                        t(personalizedPriceDescription[showInputPromo], {monnaie:devise})
                                    :
                                        t(personalizedPriceDescription[showInputPromo])
                                    }
                                </div> 
                            }
                            {(!showInputPromo) ?
                                false
                            :
                                <>
                                    <>
                                        <label htmlFor="description de la promotion">{t('personalized_price')+' :'}</label>
                                        <div className="input-group">
                                            {(personalizedPricePrefixe.includes(showInputPromo)) ?
                                                <div className="input-group-prepend">
                                                    <div className="input-group-text rounded-0" >{addOn}</div>
                                                </div>
                                            :
                                                false
                                            }
                                            <input  className='form-control mb-2' type="text" aria-describedby="basic-addon1" {...register('value', {required: true})} />
                                        </div>
                                        {errors.value?.type === 'required' && (
                                        <div className="text-danger mt-1 ml-2">
                                            {t('fieldRequired')}
                                        </div>
                                        )}
                                        <div className="form-group">
                                            <label htmlFor="date de transfert">{t('beginPersonalizedPrice')+' :'}</label>
                                            <input  type='date' className="form-control" {...register('begin')}/>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="date de transfert">{t('endPersonalizedPrice')+' :'}</label>
                                            <input  type='date' className="form-control" {...register('end')}/>
                                        </div>
                                    </>
                                    {(apiError) ? <div className="alert alert-danger mt-3" dangerouslySetInnerHTML={{ __html: apiError }}></div> : false}
                                </>
                            }  
                            <button disabled={validButton} className="btn btn-primary mt-3">
                                {validButton ? <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> : t('btnValidate')}
                            </button>
                        </>
                    }
                </form>
            }
        </>
    )
}

export default CreatePersonalizedPriceForm;